import React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import DropdownMenuContent from "./DropdownMenuContent";
import DropdownMenuGroup from "./DropdownMenuGroup";
import DropdownMenuItem from "./DropdownMenuItem";
import DropdownMenuItemCustom from "./DropdownMenuItemCustom";
import DropdownMenuItemLink from "./DropdownMenuItemLink";
import MenuSeparator from "./DropdownMenuSeparator";
import DropdownMenuTrigger from "./DropdownMenuTrigger";
import {
  getMenuContentComponent,
  getMenuTriggerComponent,
} from "./dropdownMenuUtils";

import "./DropdownMenu.scss";

const DropdownMenu = ({
  children,
  open,
  onOpenChange,
  placement,
}: {
  children?: React.ReactNode;
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  placement?: "top" | "bottom";
}) => {
  const MenuTriggerComp = getMenuTriggerComponent(children);
  const MenuContentComp = getMenuContentComponent(children);

  const MenuContentCompWithPlacement =
    MenuContentComp && React.isValidElement(MenuContentComp)
      ? React.cloneElement(MenuContentComp as React.ReactElement<any>, {
          placement,
        })
      : MenuContentComp;

  return (
    <DropdownMenuPrimitive.Root
      open={open}
      onOpenChange={(open) => onOpenChange?.(open)}
    >
      <div
        className="dropdown-menu-wrapper"
        style={{ display: "contents" }}
      >
        {MenuTriggerComp}
        {MenuContentCompWithPlacement}
      </div>
    </DropdownMenuPrimitive.Root>
  );
};

DropdownMenu.Trigger = DropdownMenuTrigger;
DropdownMenu.Content = DropdownMenuContent;
DropdownMenu.Item = DropdownMenuItem;
DropdownMenu.ItemLink = DropdownMenuItemLink;
DropdownMenu.ItemCustom = DropdownMenuItemCustom;
DropdownMenu.Group = DropdownMenuGroup;
DropdownMenu.Separator = MenuSeparator;

export default DropdownMenu;
DropdownMenu.displayName = "DropdownMenu";
